<template>
  <div>
    <h1>뉴스 보도자료<small class="ml-3 text-muted">{{ news.id > 0 ? '수정' : '추가'}}</small></h1>
    <div class="card" v-if="news !== null">
      <div class="card-body">
        <div class="form-group">
          <label for="news-title">제목</label>
          <input type="text" class="form-control"
                 id="news-title"
                 placeholder=""
                 v-model="news.title"
                 name="news-title"
                 v-validate="'required'"
                 :class="{'is-invalid': errors.has('news-title')}">
          <div class="invalid-feedback" v-if="errors.has('news-title')">제목을 입력하세요.</div>
        </div>

        <label>내용</label>
        <vue-editor
          class="mb-3"
          v-model="news.content"
          v-validate="'required'"
          data-vv-name="news-content"
          :useCustomImageHandler="true"
          @image-added="handleImageAdded" />
        <div class="invalid-feedback" :class="{'d-block': errors.has('news-content')}" v-if="errors.has('news-content')">내용을 입력하세요.</div>

        <div class="form-group">
          <label for="news-at">보도일자</label>
          <v-date-picker v-model="news.newsAt" :popover="{ visibility: 'click' }">
            <input type="text"
                   class="form-control"
                   id="news-at"
                   placeholder=""
                   name="news-at"
                   readonly="readonly"
                   v-model="newsAt"
                   v-validate="'required'"
                   :class="{'is-invalid': errors.has('news-at')}">
          </v-date-picker>
          <div class="invalid-feedback"
               :class="{'d-block' : errors.has('news-at')}"
               v-if="errors.has('news-at')">보도 일자를 입력하세요.
          </div>
        </div>

        <div class="form-group">
          <label for="news-link">기사 링크</label>
          <input type="text" class="form-control"
                 id="news-link"
                 placeholder=""
                 v-model="news.link"
                 name="news-link"
                 v-validate="'required'"
                 :class="{'is-invalid': errors.has('news-link')}">
          <div class="invalid-feedback" v-if="errors.has('news-link')">링크를 입력하세요.</div>
        </div>

        <div class="form-group">
          <label>공개 여부</label>
          <div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="news-status-true" name="news-status" class="custom-control-input" :value="true"
                     v-model="news.status">
              <label class="custom-control-label" for="news-status-true">공개</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="news-status-false" name="news-status" class="custom-control-input" :value="false"
                     v-model="news.status">
              <label class="custom-control-label" for="news-status-false">비공개</label>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>썸네일 이미지<small v-if="news.img !== null && news.img !== ''" class="text-muted ml-3">{{news.img}}</small></label>
          <div v-if="news.img !== null && news.img !== ''" class="mb-3">
            <img :src="`${publicPath}upload/news/${news.img}`" />
          </div>
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="thumb" name="thumb" ref="thumb" accept="image/*" @change="handleThumb">
            <label class="custom-file-label" for="thumb">
              {{ this.thumb !== null ? this.thumb.name : 'Choose file'}}
            </label>
          </div>
        </div>
      </div>
    </div>


    <div class="text-center my-5">
      <button type="button" class="btn btn-outline-secondary mx-2" @click="submit">저장</button>
      <button type="button" class="btn btn-outline-secondary mx-2" @click="$router.back()">취소</button>
    </div>
  </div>
</template>

<script>

import { VueEditor } from 'vue2-editor';

export default {
  name: 'AdminNewsWrite',
  components: {
    VueEditor,
  },
  computed: {
    newsAt() {
      return this.news.newsAt ? this.moment(this.news.newsAt).format('YYYY-MM-DD') : '';
    },
  },
  data() {
    return {
      news: null,
      thumb: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['YYYY-MM-DD'], // Only for `v-date-picker`
        dayPopover: 'L', // Only for `v-date-picker`
        data: ['YYYY-MM-DD'],
      },
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.axios.get(`/admin/media/news/${this.$route.params.id}`)
        .then(({ data }) => {
          this.news = data;
          this.thumb = null;
        });
    } else {
      this.news = {
        id: 0,
        title: '',
        content: '',
        newsAt: '',
        link: '',
        img: '',
        status: false,
      };
    }
  },
  methods: {
    handleImageAdded(file, Editor, cursorLocation) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('dir', 'news');
      formData.append('ext', file.name.split('.').pop());

      this.$axios({
        url: '/admin/file',
        method: 'POST',
        data: formData,
      })
        .then((result) => {
          // const { url } = result.data; // Get url from response
          Editor.insertEmbed(cursorLocation, 'image', result.data);
          // resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleThumb() {
      this.thumb = this.$refs.thumb.files.length ? this.$refs.thumb.files[0] : null;
    },
    async submit() {
      await this.$validator.validateAll();

      if (this.errors.any()) return;

      const formData = new FormData();

      if (this.news.id) {
        formData.append('id', this.news.id);
      }
      formData.append('title', this.news.title);
      formData.append('content', this.news.content);
      formData.append('newsAt', this.moment(this.news.newsAt).format('YYYY-MM-DD'));
      formData.append('link', this.news.link);
      formData.append('status', this.news.status);
      if (this.thumb) { formData.append('img', this.thumb); }

      this.$axios({ url: '/admin/media/news', method: this.news.id > 0 ? 'PUT' : 'POST', data: formData })
        .then(() => {
          this.$router.push({ name: 'adminNewsList' });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>

</style>
